import React, { useEffect, useState } from 'react';
import { Button, Layout, Menu } from 'antd';
import {
    UserOutlined,
    LaptopOutlined,
    NotificationOutlined,
    LeftOutlined,
    RightOutlined,
    FileTextOutlined,

} from '@ant-design/icons';
import './styles.sider.scss'
import { useNavigate } from 'react-router-dom';
import { MainState } from '../../MainProvider';


const { Sider } = Layout;

const SiderComponent: React.FC = () => {

    const [collapsed, setCollapsed] = useState(false);
    const { isCollapsed, setIsCollapsed } = MainState();
    const [selectKey, setSelectKey] = useState('expert-management');
    const { isLogin, setIsLogin, isAdmin, setIsAdmin, lstAction, setLstAction, lstCategory, setLstCategory, lstUser, setLstUser } = MainState();
    const navigate = useNavigate();

    useEffect(() => {
        setIsCollapsed(collapsed);
    }, [collapsed]);

    useEffect(() => {
        if (localStorage.getItem('role') === 'superadmin') {
            setIsAdmin(true);
        }
        else {
            setIsAdmin(false);
        }
    }, []);

    useEffect(() => {
        if (window.location.pathname === '/expert-management') {
            setSelectKey('expert-management');
        }
        if (window.location.pathname === '/request-management') {
            setSelectKey('request-management');
        }
        if (window.location.pathname === '/partnet-appraisal') {
            setSelectKey('partnet-appraisal');
        }
        if (window.location.pathname === '/project-appraisal') {
            setSelectKey('project-appraisal');
        }
        if (window.location.pathname === '/document-managment') {
            setSelectKey('document-managment');
        }

        if (window.location.pathname === '/user-management' || window.location.pathname.includes('/user-management-history')) {
            setSelectKey('user-management');
        }

    }, [window.location.pathname]);

    const onCollapse = (collapsed: any) => {
        setCollapsed(collapsed);
    };

    const handleMenuClick = (key: any) => {
        console.log(key);
        navigate(`/${key}`);
    }

    return (
        <Sider
            width={270}
            className="site-layout"
            collapsible
            collapsed={collapsed}
            onCollapse={onCollapse}
        >

            {
                localStorage.getItem('role') !== 'superadmin' ?
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['expert-management']}
                        defaultOpenKeys={['expert-management']}
                        style={{ height: '100%', borderRight: 0 }}
                        onClick={({ key }) => handleMenuClick(key)}
                        selectedKeys={[selectKey]}
                    >

                        <Menu.SubMenu
                            key="expert-management"
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
                                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0m.6-3h16.8M3.6 15h16.8" />
                                        <path d="M11.5 3a17 17 0 0 0 0 18m1-18a17 17 0 0 1 0 18" />
                                    </g>
                                </svg>
                            }
                            title="Lĩnh vực đối ngoại">
                            <Menu.Item key="expert-management" >Quản lý chuyên gia</Menu.Item>
                            <Menu.Item key="request-management" >Quản lý ý kiến</Menu.Item>
                        </Menu.SubMenu>
                        <Menu.SubMenu key="partnet-appraisal"
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 24 24">
                                    <path fill="currentColor" fill-rule="evenodd" d="M14.325 3.75h-4.65A3.75 3.75 0 0 1 6.75 6.675v.65a3.75 3.75 0 0 1 2.925 2.925h4.65a3.75 3.75 0 0 1 2.925-2.925v-.65a3.75 3.75 0 0 1-2.925-2.925m.605-1.497q-.412-.004-.878-.003H9.948q-.466 0-.877.003a1 1 0 0 0-.164.003c-.452.008-.853.027-1.201.074c-.628.084-1.195.27-1.65.725c-.456.456-.642 1.023-.726 1.65c-.047.349-.066.75-.074 1.202a1 1 0 0 0-.003.163q-.004.413-.003.878v.104q0 .465.003.878a1 1 0 0 0 .003.163c.008.453.027.853.074 1.201c.084.628.27 1.195.726 1.65c.455.456 1.022.642 1.65.726c.348.047.749.066 1.201.074a1 1 0 0 0 .164.003q.411.004.877.003h4.104q.465 0 .878-.003a1 1 0 0 0 .163-.003c.453-.008.854-.027 1.201-.074c.628-.084 1.195-.27 1.65-.726c.456-.455.642-1.022.726-1.65a11 11 0 0 0 .074-1.201a1 1 0 0 0 .003-.163q.004-.413.003-.878v-.104q0-.465-.003-.878a1 1 0 0 0-.003-.163a11 11 0 0 0-.074-1.201c-.084-.628-.27-1.195-.725-1.65c-.456-.456-1.023-.642-1.65-.726a11 11 0 0 0-1.202-.074a1 1 0 0 0-.163-.003m.964 1.541a2.26 2.26 0 0 0 1.312 1.312a5 5 0 0 0-.023-.2c-.061-.462-.169-.66-.3-.79s-.327-.237-.788-.3a5 5 0 0 0-.2-.022m1.312 5.1a2.26 2.26 0 0 0-1.312 1.312q.105-.01.2-.022c.462-.063.66-.17.79-.3s.238-.328.3-.79q.012-.095.022-.2m-9.1 1.312a2.26 2.26 0 0 0-1.312-1.312q.01.105.023.2c.062.462.169.66.3.79s.327.237.788.3q.096.012.201.022m-1.312-5.1a2.26 2.26 0 0 0 1.312-1.312q-.105.01-.2.023c-.462.062-.66.169-.79.3s-.237.327-.3.788zM12 6.75a.25.25 0 1 0 0 .5a.25.25 0 0 0 0-.5M10.25 7a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0m-1.566 7.448c1.866-.361 3.863-.28 5.48.684c.226.135.44.304.625.512c.376.423.57.947.579 1.473q.286-.186.577-.407l1.808-1.365a2.64 2.64 0 0 1 3.124 0c.835.63 1.169 1.763.57 2.723c-.425.681-1.065 1.624-1.717 2.228c-.66.61-1.597 1.124-2.306 1.466c-.862.416-1.792.646-2.697.792c-1.85.3-3.774.254-5.602-.123a14.3 14.3 0 0 0-2.865-.293H4a.75.75 0 0 1 0-1.5h2.26c1.062 0 2.135.111 3.168.324a14.1 14.1 0 0 0 5.06.111c.828-.134 1.602-.333 2.284-.662c.683-.33 1.451-.764 1.938-1.215c.493-.457 1.044-1.248 1.465-1.922c.127-.204.109-.497-.202-.732c-.37-.28-.947-.28-1.316 0l-1.807 1.365c-.722.545-1.61 1.128-2.711 1.304a9 9 0 0 1-.347.048q-.086.015-.179.02a10 10 0 0 1-1.932 0a.75.75 0 1 1 .141-1.493a8.5 8.5 0 0 0 1.668-.003l.03-.003a.742.742 0 0 0 .15-1.138a1.2 1.2 0 0 0-.275-.222c-1.181-.705-2.759-.822-4.426-.5a12.1 12.1 0 0 0-4.535 1.935a.75.75 0 0 1-.868-1.224a13.6 13.6 0 0 1 5.118-2.183" clip-rule="evenodd" />
                                </svg>
                            }
                            title="Lĩnh vực kinh tế">
                            <Menu.Item key="partnet-appraisal" >Thẩm định đối tác/ Công ty hợp tác</Menu.Item>
                            <Menu.Item key="project-appraisal" >Thẩm định dự án</Menu.Item>
                        </Menu.SubMenu>

                        <Menu.Item
                            key="document-managment"
                            icon={<FileTextOutlined />}
                            className='menu-item-user-management'
                        >
                            Quản lý công văn
                        </Menu.Item>
                    </Menu>
                    :
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['user-management']}
                        defaultOpenKeys={['user-management']}
                        style={{ height: '100%', borderRight: 0 }}
                        onClick={({ key }) => handleMenuClick(key)}
                        selectedKeys={[selectKey]}
                    >
                        <Menu.Item
                            key="user-management"
                            icon={<UserOutlined />}
                            className='menu-item-user-management'
                        >
                            Quản lý người dùng
                        </Menu.Item>
                    </Menu>
            }

            <Button
                className='button-sider'
                type="text"
                icon={!collapsed ? <LeftOutlined /> : <RightOutlined />}
                onClick={() => setCollapsed(!collapsed)}

            />
        </Sider>
    );
};

export default SiderComponent;